"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractAxiosErrorData = void 0;
exports.executeRequest = executeRequest;
const promise_utils_1 = require("@api3/promise-utils");
const axios_1 = __importDefault(require("axios"));
const DEFAULT_TIMEOUT_MS = 10_000;
const extractAxiosErrorData = (error) => {
    // Inspired by: https://axios-http.com/docs/handling_errors
    return {
        response: error.response?.data,
        message: error.message,
        code: error.code,
    };
};
exports.extractAxiosErrorData = extractAxiosErrorData;
async function executeRequest(request, options) {
    const { url, method, body, headers = {}, queryParams = {}, timeout = DEFAULT_TIMEOUT_MS } = request;
    const goAxios = await (0, promise_utils_1.go)(async () => (0, axios_1.default)({
        url,
        method,
        headers,
        data: body,
        params: queryParams,
        timeout,
    }), options);
    if (!goAxios.success) {
        return {
            success: false,
            errorData: (0, exports.extractAxiosErrorData)(goAxios.error),
            data: undefined,
            statusCode: goAxios.error.status,
        };
    }
    const response = goAxios.data;
    return { success: true, errorData: undefined, data: response.data, statusCode: response.status };
}
//# sourceMappingURL=index.js.map